import { Link, useLocation } from "react-router-dom";

const items = [
  { path: "/integrations", label: "Connectors" },
  { path: "/integrations/channels", label: "Channels" },
  { path: "/integrations/exceptions", label: "Integration Exceptions" },
  { path: "/integrations/carriers", label: "Carriers" },
  { path: "/integrations/automation", label: "Sync & Events" },
];

export function IntegrationsNav() {
  const location = useLocation();
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6">
      <h3 className="text-sm font-semibold text-slate-800 mb-3">Integrations</h3>
      <nav className="space-y-1">
        {items.map((item) => {
          const active = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`block px-3 py-2 rounded-lg text-sm whitespace-nowrap ${
                active ? "bg-emerald-50 text-emerald-700 font-medium" : "text-slate-600 hover:bg-slate-50"
              }`}
            >
              {item.label}
            </Link>
          );
        })}
      </nav>
      <div className="mt-4 pt-4 border-t border-slate-100 text-xs text-slate-400 leading-relaxed">
        Connect your marketplace, carrier and other services so they share data with the rest of the platform.
      </div>
    </div>
  );
}